export default __webpack_public_path__ + "static/media/support-message-icon.26817e12.svg";